import React, { useCallback, useMemo } from 'react';
import { Card, Paragraph } from '@leafwell/components';

import HeadingBody from './heading-body';
import LineCounter from './line-counter';
import { useWordPressContext } from 'contexts/wordpress-provider';
import { getLargestRemainderPercentages } from 'lib/utils/getLargestRemainderPercentages';
import { useDasboardContext } from 'contexts/dashboard-context';
import StudyLegend from './study-legend';

const DashboardHeader: React.FC<{ id: string }> = ({ id }) => {
  const { translations } = useWordPressContext();
  const {
    results,
    studies: { total },
  } = useDasboardContext();
  const percentages = useMemo(
    () => getLargestRemainderPercentages(results.map(({ count }) => count)),
    [results],
  );
  const getPercentage = useCallback(
    key => percentages.find(({ key: itemKey }) => key === itemKey)?.value || 0,
    [percentages],
  );

  return (
    <Card
      {...{
        className:
          'md:flex md:items-center gap-6 xl:gap-x-16 bg-white border-0',
        id,
        filled: false,
        rounded: true,
        size: 'large',
        tagName: 'header',
      }}
    >
      <p className="grid">
        {translations['Total studies done']}
        <HeadingBody
          {...{ level: '2', tagName: 'span', title: total.toString() }}
        />
      </p>
      {results.map(({ count, result }, key) => (
        <article className="grow grid gap-3 items-start" key={result}>
          <Paragraph
            size="large"
            className="grid grid-cols-inline-form justify-between gap-x-6 gap-y-1 leading-tight lowercase"
            tagName="div"
          >
            {getPercentage(key)}%
            <StudyLegend
              {...{
                className: 'jusitfy-self-end',
                result,
                showLabel: false,
              }}
            />
            <LineCounter
              {...{
                className: 'col-span-full',
                color: 'black',
                count,
                total,
              }}
            />
          </Paragraph>
          <Paragraph size="small">
            {translations['A total of %d results were found.'].replace(
              '%d',
              count.toString(),
            )}
          </Paragraph>
        </article>
      ))}
    </Card>
  );
};

export default DashboardHeader;
